import { INPUT_STATE_DEFAULT, INPUT_STATE_DISABLED, INPUT_STATE_ERROR, INPUT_STATE_VALID } from '~kui/constants/kui';

export const baseInputClasses
  = 'placeholder:text-muted-foreground border-box inline-flex w-full items-center justify-between gap-1 rounded-2xl border-2 bg-white text-sm leading-none shadow-md outline-none data-disabled:cursor-not-allowed';

export const inputStateVariants = {
  [INPUT_STATE_ERROR]: 'border-destructive',
  [INPUT_STATE_VALID]: 'border-success-foreground',
  [INPUT_STATE_DEFAULT]: 'border-input',
  [INPUT_STATE_DISABLED]: 'border-input bg-muted/50 text-muted-foreground',
};
